import styled from 'styled-components';

import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './game-image-container.default.box';
import {LOBBY_PAGE} from '../../../../../themes/css-global-classes';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';
import {SINGLE_GAME_IMAGE} from '../../../css-constants';


function common(): string {
    return `
        max-width: 19rem;
         & > .${SINGLE_GAME_IMAGE} {
            top: 4px;
            position: relative;
         }
    `;
}

const PcBox = styled(BasePcBox)`
    ${common()}

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        &img {
            min-height: 139px
            .${LOBBY_PAGE} & {
                min-height: 125px;
            }
        }
    }
`;

const MobileBox = styled(BaseMobileBox)`
    ${common()}
`;

export const GameImageContainerCasino777Box = styledByDevice(PcBox, MobileBox);
